import { useAppSelector } from 'reduxTyped'

import { GenericTriggerConversionRules } from 'common/builder/components/chart/FlowChart/adapters/generic/triggers/converter.rules'
import { FlowChartBroadcastTrigger } from 'common/builder/components/chart/FlowChart/constants/FlowChartBroadcastTrigger'
import { predicateConverter } from 'common/builder/components/chart/FlowChart/lib/PredicateConverter'
import { IFlowTrigger } from 'common/flow/flowInterfaces'
import { isBroadcastFlow } from 'common/flow/models/Flow/helpers'
import { getSortedFlowTriggers, getById as getFlowById } from 'common/flow/selectors/flowSelectors'

export const useFlowChartTriggers = ({
  flowId,
  externalTriggers = [],
}: {
  flowId: string
  externalTriggers?: IFlowTrigger[]
}) => {
  const triggers = useAppSelector((state) => {
    const sortedTriggers = getSortedFlowTriggers(state, flowId)
    const flow = getFlowById(state, flowId)

    if (Boolean(flow?.id) && isBroadcastFlow(flow?.id)) {
      return [FlowChartBroadcastTrigger]
    }

    const triggers = [...sortedTriggers, ...externalTriggers]

    return predicateConverter.convertEntities({
      entities: triggers,
      rules: GenericTriggerConversionRules,
      payload: {
        state,
      },
    })
  })

  return triggers
}
